import { render, staticRenderFns } from "./ecpa-info.vue?vue&type=template&id=f6e1e868&scoped=true&"
import script from "./ecpa-info.ts?vue&type=script&lang=ts&"
export * from "./ecpa-info.ts?vue&type=script&lang=ts&"
import style0 from "./ecpa-info.scss?vue&type=style&index=0&id=f6e1e868&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e1e868",
  null
  
)

export default component.exports